import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { useNavigate } from 'react-router-dom';
import { useMenu } from '../../../../hooks/use-menu';
import { ImportContractDialog } from '../../../../components/new-design/surfaces/VySearchbar/vy-search-bar-components/ImportContractDialog/ImportContractDialog';
import { PlanCreationOptionsDialog } from '../../../plans/components/PlanCreationOptionsDialog';
import { HOME_QUICK_ACTIONS } from './config';
import { VyDivider } from '../../../../components/new-design/atoms';
import { useDialog } from '../../../../hooks/use-dialog.ts';
import { getSelectorAttribute, homePageWidgetsSelectors } from '@vy/app-selectors';

export const HomeQuickActions = () => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();
  const navigate = useNavigate();
  const {
    isDialogOpen: isImportDialogOpen,
    handleOpen: openImportDialog,
    handleClose: closeImportDialog,
  } = useDialog(false);
  const {
    isDialogOpen: isPlanCreationOptionsDialogOpen,
    handleOpen: openPlanCreationOptionsDialog,
    handleClose: closePlanCreationOptionsDialog,
  } = useDialog(false);

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        {...getSelectorAttribute(homePageWidgetsSelectors.quickActionsButton)}
        sx={{
          width: 48,
          height: 48,
          bgcolor: '#07105F',
          color: '#fff',
          '&:hover': { bgcolor: '#1a2a3d' },
        }}
      >
        <AddIcon />
      </IconButton>

      <Menu
        anchorEl={anchorElement}
        open={isOpen}
        onClose={handleMenuClose}
        sx={{
          '& .MuiMenu-paper': {
            borderRadius: '8px',
            minWidth: '200px',
            boxShadow: '0px 4px 24px 0px rgba(16, 30, 54, 0.16)',
          },
        }}
      >
        {HOME_QUICK_ACTIONS.map((action) => (
          <MenuItem
            key={action.label}
            onClick={() => {
              handleMenuClose();
              if (action.action.kind === 'navigate') {
                navigate(action.action.path);
              } else if (action.action.kind === 'planCreationOptions') {
                openPlanCreationOptionsDialog();
              }
            }}
          >
            <ListItemIcon sx={{ minWidth: '32px !important', color: '#020F20' }}>{action.icon}</ListItemIcon>
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
        <VyDivider />
        <MenuItem
          onClick={() => {
            handleMenuClose();
            openImportDialog();
          }}
        >
          <ListItemIcon sx={{ minWidth: '32px !important', color: '#020F20' }}>
            <VyIcon icon="AiSparkSmall" />
          </ListItemIcon>
          <ListItemText>Smart contract upload</ListItemText>
          <Box
            sx={{
              marginLeft: 1,
              borderRadius: '4px',
              bgcolor: '#E7F2FF',
              color: '#0521FF',
              fontSize: '10px',
              fontWeight: 600,
              lineHeight: 1,
              padding: '2px 4px',
            }}
          >
            New
          </Box>
        </MenuItem>
      </Menu>

      <ImportContractDialog open={isImportDialogOpen} onClose={closeImportDialog} />
      <PlanCreationOptionsDialog
        isOpen={isPlanCreationOptionsDialogOpen}
        onClose={closePlanCreationOptionsDialog}
      />
    </>
  );
};
